export default {
    path:'/logout',
    preload:false,
    middlewares: [
        "rms_ui/logoutMiddleware",
    ]
}